export default "__VITE_ASSET__CZJr9j_D__"